function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import l from "../util/net.js";
import r from "../managers/braze-instance.js";
import ControlMessage from "./models/control-message.js";
import HtmlMessage from "./models/html-message.js";
import InAppMessage from "./models/in-app-message.js";
import InAppMessageButton from "./models/in-app-message-button.js";
import c from "../common/event-logger.js";
import { newInAppMessageFromJson as ut } from "./in-app-message-factory.js";
import { randomInclusive as a } from "../util/math.js";
import F from "../models/request-result.js";
import { logger as N, EventTypes as d } from "../../shared-lib/index.js";
import u from "../managers/subscription-manager.js";
import pt from "../triggers/models/trigger.js";
import { BRAZE_ACTION_URI_REGEX as to } from "../util/validation-utils.js";
import { containsPushPrimerBrazeAction as gt, containsUnknownBrazeAction as ft, getDecodedBrazeAction as eo, ineligibleBrazeActionURLErrorMessage as dt, INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES as jt } from "../util/braze-actions.js";
import vt from "../Push/utils/push-utils.js";
import h from "../util/request-header-utils.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import { FullScreenMessage, ModalMessage, SlideUpMessage } from "./index.js";

var ea = /*#__PURE__*/function () {
  function ea(t, e, s, i) {
    _classCallCheck(this, ea);

    this.S = t, this.T = e, this.C = s, this.Cs = i, this.S = t, this.T = e, this.C = s, this.Cs = i, this.Mi = new u(), r.F(this.Mi), this.Bi = 1e3, this._i = 6e4, this.Pi = null, this.Gi = null, this.$i = null;
  }

  _createClass(ea, [{
    key: "Oi",
    value: function Oi() {
      return this.Mi;
    }
  }, {
    key: "Xi",
    value: function Xi(t) {
      return this.Mi.Dt(t);
    }
  }, {
    key: "Hi",
    value: function Hi() {
      return this.Pi;
    }
  }, {
    key: "Ji",
    value: function Ji(t) {
      this.Pi = t;
    }
  }, {
    key: "ut",
    value: function ut(t, e, s, i) {
      var r = new F();
      var n;

      if (e === d.Ki || t instanceof ControlMessage) {
        if (!t._t()) return N.info("This in-app message has already received an impression. Ignoring analytics event."), r;
      } else if (e === d.Li || t instanceof HtmlMessage && e === d.Qi) {
        if (!t.$t(i)) return N.info("This in-app message has already received a click. Ignoring analytics event."), r;
      }

      return n = t instanceof ControlMessage ? {
        trigger_ids: [t.triggerId]
      } : this.Vi(t), null == n ? r : (t.messageExtras && (n.message_extras = t.messageExtras), null != s && (n.bid = s), c.ut(e, n));
    }
  }, {
    key: "Wi",
    value: function Wi(t, e) {
      var s = new F();
      if (!t.$t()) return N.info("This in-app message button has already received a click. Ignoring analytics event."), s;
      var i = this.Vi(e);
      return null == i ? s : t.id === InAppMessageButton.Yi ? (N.info("This in-app message button does not have a tracking id. Not logging event to Braze servers."), s) : (null != t.id && (i.bid = t.id), c.ut(d.Qi, i));
    }
  }, {
    key: "Zi",
    value: function Zi(t) {
      var e = t.messageFields;
      return null != e && e.is_push_primer || !1;
    }
  }, {
    key: "Ir",
    value: function Ir(t) {
      if (!(t instanceof InAppMessage)) return;

      var e = function e(t) {
        if (!t) return;
        var e = eo(t);
        return ft(e) ? dt(jt.Mr, "In-App Message") : gt(e) && !vt.Tr() ? dt(jt.wr, "In-App Message") : void 0;
      };

      if (this.Zi(t) && !vt.Tr()) return "In-App Message contains a push prompt, but is not eligible for a push prompt. Ignoring.";
      var s = t.buttons || [];
      var i;

      var _iterator = _createForOfIteratorHelper(s),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t = _step.value;
          if (_t.clickAction === InAppMessage.ClickAction.URI && _t.uri && to.test(_t.uri) && (i = e(_t.uri), i)) return i;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return t.clickAction === InAppMessage.ClickAction.URI && t.uri && to.test(t.uri) ? e(t.uri) : void 0;
    }
  }, {
    key: "Br",
    value: function Br(t, e) {
      e !== this.$i && this._r(), this.Gi = t, this.$i = e;
    }
  }, {
    key: "_r",
    value: function _r() {
      null != this.Gi && (clearTimeout(this.Gi), this.Gi = null, this.$i = null);
    }
  }, {
    key: "qr",
    value: function qr(t, e, s, i) {
      var _this = this;

      var r = this.S;
      if (!r) return;
      this.$i && t.triggerId !== this.$i && (this._r(), h.vi(this.C, h.O.Er));
      var n = r.Gr(!1, !1),
          o = r.H(n);
      o.template = {
        trigger_id: t.triggerId,
        trigger_event_type: e
      }, null != s && (o.template.data = s.Nr());
      var u = r.J(o, h.O.Er);
      r.V(o, function () {
        var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
        var n = _this.S;
        if (!n) return;
        var p = new Date().valueOf();
        h.W(_this.C, h.O.Er, p), -1 !== r && u.push(["X-Braze-Req-Tokens-Remaining", r.toString()]);
        var m,
            c,
            g = !1;
        l.Y({
          url: "".concat(n.Z(), "/template/"),
          data: o,
          headers: u,
          tt: function tt(e) {
            if (!n.st(o, e, u)) return void ("function" == typeof t.$r && t.$r());
            if (n.it(), null == e || null == e.templated_message) return;
            var s = e.templated_message;
            if (s.type !== pt.Or.Cr) return;
            var i = ut(s.data);
            if (null == i) return;

            var r = _this.Ir(i);

            if (r) return N.error(r), void ("function" == typeof t.$r && t.$r());
            "function" == typeof t.Xr && t.Xr(i);
          },
          error: function error(e) {
            g = !0, m = e, c = "getting user personalization for message ".concat(t.triggerId, ".");
          },
          nt: function nt(r, o) {
            if (new Date().valueOf() - t.Hr < t.Jr) {
              var _r2 = 0;

              if (g) {
                var _e = Math.min(t.Jr, _this._i),
                    _s = _this.Bi;

                null == i && (i = _s), _r2 = Math.min(_e, a(_s, 3 * i));
              }

              n.rt(o, function () {
                _this.qr(t, e, s, _r2);
              }, h.O.Er, function (e) {
                return _this.Br(e, t.triggerId);
              }, function () {
                return _this._r();
              }, _r2);
            }

            g && n.et(m, c);
          }
        });
      }, h.O.Er);
    }
  }, {
    key: "Vi",
    value: function Vi(t) {
      if (null == t.triggerId) return N.info("The in-app message has no analytics id. Not logging event to Braze servers."), null;
      var e = {};
      return null != t.triggerId && (e.trigger_ids = [t.triggerId]), e;
    }
  }, {
    key: "sn",
    value: function sn(t) {
      return !!this.C && !(!(t && t instanceof InAppMessage && t.constructor !== InAppMessage) || t instanceof ControlMessage) && this.C.Bt(s.gt.Kr, t.bt());
    }
  }, {
    key: "Ar",
    value: function Ar() {
      if (!this.C) return null;
      var t = this.C.ft(s.gt.Kr);
      if (!t) return null;
      var e;

      switch (t.type) {
        case InAppMessage.bo.Lr:
          e = FullScreenMessage.Qr(t);
          break;

        case InAppMessage.bo.Ur:
        case InAppMessage.bo.po:
        case InAppMessage.bo.Jo:
          e = HtmlMessage.Qr(t);
          break;

        case InAppMessage.bo.Vr:
        case InAppMessage.bo.Fo:
          e = ModalMessage.Qr(t);
          break;

        case InAppMessage.bo.Wr:
          e = SlideUpMessage.Qr(t);
      }

      return e && this.Yr(), e;
    }
  }, {
    key: "Yr",
    value: function Yr() {
      this.C && this.C.Ut(s.gt.Kr);
    }
  }]);

  return ea;
}();

export { ea as default };